module.exports = "/static-assets/_next/static/images/pre-e130dab3cf89ba0cef9d2376520e06e7.jpg";